import React, { useMemo } from "react";
import { countries, states, districts } from "../data/locationData";

const LocationSelectors = ({
  country = "",
  state = "",
  district = "",
  onChange,
  persistToLocalStorage = true,
  requiredFields = { country: true, state: true, district: false },
  labels = {
    country: "Country",
    state: "State",
    district: "District",
  },
}) => {
  const availableStates = useMemo(() => {
    if (!country) return [];
    return states[country] || [];
  }, [country]);

  const availableDistricts = useMemo(() => {
    if (!state) return [];
    return districts[state] || [];
  }, [state]);

  const emit = (next) => {
    if (persistToLocalStorage) {
      if (Object.prototype.hasOwnProperty.call(next, "country")) {
        if (next.country) localStorage.setItem("selectedCountry", next.country);
        else localStorage.removeItem("selectedCountry");
      }

      if (Object.prototype.hasOwnProperty.call(next, "state")) {
        if (next.state) localStorage.setItem("selectedState", next.state);
        else localStorage.removeItem("selectedState");
      }

      if (Object.prototype.hasOwnProperty.call(next, "district")) {
        if (next.district) localStorage.setItem("selectedDistrict", next.district);
        else localStorage.removeItem("selectedDistrict");
      }
    }

    onChange?.(next);
  };

  const handleCountryChange = (e) => {
    const nextCountry = e.target.value;
    emit({ country: nextCountry, state: "", district: "" });
  };

  const handleStateChange = (e) => {
    const nextState = e.target.value;
    emit({ state: nextState, district: "" });
  };

  const handleDistrictChange = (e) => {
    emit({ district: e.target.value });
  };

  return (
    <div className="form-page-row">
      <div className="form-page-col">
        <label>{labels.country}{requiredFields.country ? " *" : ""}</label>
        <select value={country} onChange={handleCountryChange} required={requiredFields.country}>
          <option value="">Select Country</option>
          {countries.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>

      <div className="form-page-col">
        <label>{labels.state}{requiredFields.state ? " *" : ""}</label>
        <select
          value={state}
          onChange={handleStateChange}
          disabled={!country}
          required={requiredFields.state}
        >
          <option value="">Select State</option>
          {availableStates.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>

      <div className="form-page-col">
        <label>{labels.district}{requiredFields.district ? " *" : ""}</label>
        <select
          value={district}
          onChange={handleDistrictChange}
          disabled={!state}
          required={requiredFields.district}
        >
          <option value="">Select District</option>
          {availableDistricts.map((d) => (
            <option key={d} value={d}>
              {d}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LocationSelectors;
